import React from 'react';
import $ from 'jquery';

class Preloader extends React.Component {
    componentDidMount(){
        const removePreloader = function () {
            if ($('#preloader').length) {
              $('#preloader').delay(100).fadeOut('slow', function () {
                $(this).remove();
              });
            }
        };

        if (document.readyState === 'complete') {
            removePreloader();
        } else {
            $(window).on('load', removePreloader);
        }
    }

    render(){
        return <div id="preloader"></div>;
    }
}

export default Preloader;



